import { JsonPatch } from './jsonPatch';
export class JsonPatchWithId {
  id: string;
  jsonPatchDocument: JsonPatch[];
}
